module.exports = __webpack_public_path__ + "img/service.6897f6d1.jpg";